import { Box, SimpleGrid, Text, useColorMode } from "@chakra-ui/react";
import { FaPhone, FaEnvelope, FaAddressCard, FaGithub, FaLinkedin } from "react-icons/fa";
import { motion } from "framer-motion";
import { SiLinkedin } from "react-icons/si";

function ContactUs() {
  const { colorMode } = useColorMode();
  const isDark = colorMode === "dark";

  const iconVariants = {
    initial: { opacity: 0, y: -20 },
    animate: { opacity: 1, y: 0, transition: { delay: 0.3 } },
  };

  return (
    <Box maxW="700px" marginX="auto" marginTop="100px">
      <Text as="b" fontSize={["32px", "42px"]}>
        Contact Me
      </Text>
      <SimpleGrid columns={[1, 2]} gap="40px" marginTop="20px">
        
        <Box display="flex" alignItems="center">
          <motion.div variants={iconVariants} initial="initial" animate="animate">
            <FaPhone size={50} />
          </motion.div>
          <Box marginLeft="10px">
            <Text as="b" fontSize={["20px", "32px"]}>
              Phone:
            </Text>
            <Text fontSize={["17px", "18px"]}>+91 9928924747</Text>
          </Box>
        </Box>

        {/* Email */}
        <Box display="flex" alignItems="center">
          <motion.div variants={iconVariants} initial="initial" animate="animate">
            <FaEnvelope size={50} />
          </motion.div>
          <Box marginLeft="10px">
            <Text as="b" fontSize={["20px", "32px"]}>
              Email:
            </Text>
            <Text fontSize={["17px", "18px"]}>Rohitkumarprajapat303@gmail.com</Text>
          </Box>
        </Box>

        <Box display="flex" alignItems="center">
          <motion.div variants={iconVariants} initial="initial" animate="animate">
            <FaEnvelope size={50} />
          </motion.div>
          <Box marginLeft="10px">
            <Text as="b" fontSize={["20px", "32px"]}>
              Address:
            </Text>
            <Text fontSize={["17px", "18px"]}>Alwar,Rajasthan</Text>
          </Box>
        </Box>

        <Box display="flex" alignItems="center">
          <motion.div variants={iconVariants} initial="initial" animate="animate">
            <FaGithub size={50} />
          </motion.div>
          <Box marginLeft="10px">
            <Text as="b" fontSize={["20px", "32px"]}>
              Github:
            </Text>
            <Text fontSize={["17px", "18px"]}>Rohit20033</Text>
          </Box>
        </Box>

        <Box display="flex" alignItems="center">
          <motion.div variants={iconVariants} initial="initial" animate="animate">
            <SiLinkedin size={50} />
          </motion.div>
          <Box marginLeft="10px">
            <Text as="b" fontSize={["20px", "32px"]}>
              Linkdin:
            </Text>
            <Text fontSize={["17px", "18px"]}>Rohit Prajapat</Text>
          </Box>
        </Box>

        
      </SimpleGrid>
    </Box>
  );
}

export default ContactUs;
